import { config } from "../AppConfig";

async function loginUser(email, password) {
  const result = await fetch(`${config.url.API_BASE}/api/ajax/v1/auth`, {
    method: "POST",
    mode: "cors",
    headers: {
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({
      email: email,
      password: password,
    }),
  });

  return {
    status: result.status,
    data: await result.json(),
  };
}

export const authService = {
  loginUser,
};
